import { render, staticRenderFns } from "./Rallies.vue?vue&type=template&id=220cf6bc&"
import script from "./Rallies.vue?vue&type=script&lang=ts&"
export * from "./Rallies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports